import { getItemFromLocalStorage } from '../utils/getItemFromLocalStorage'

const getApiUrl = () => {
  const stageUrl = getItemFromLocalStorage('stageUrl')

  if (
    window.location.hostname === 'www.panenkafc.gg' ||
    window.location.hostname === 'panenkafc.gg' ||
    getItemFromLocalStorage('isProd')
  ) {
    return 'https://prod-api.panenkafc.gg'
  } else if (stageUrl) {
    return stageUrl
  } else {
    return 'https://test-api.panenkafc.gg'
  }
}

export default getApiUrl
